import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../../shared/headers/KonfiguracjaHeader";
import PolaczenieEkipyForm from "./components/PolaczenieEkipyForm";
import PolaczenieEkipyTable from "./components/PolaczenieEkipyTable";
import EkipyKierowcyService from "./EkipyKierowcyService";
import KierowcyService from "../../kierowcy/KierowcyService";
import utilitiesTopSelect from "../../../../../utilities/utilitiesTopSelect";
import EkipyService from "../definicjaEkipy/EkipyService";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";

export default class PolaczenieEkipyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            polaczenia: [],
            kierowcy: [],
            kierowcyTS: [],
            ekipy: [],
            ekipyTS: [],
            polaczenie: null,
            pokazFormularz: false,
        };
        this.pobierzPolaczenia = this.pobierzPolaczenia.bind(this)
        this.pokazFormularz = this.pokazFormularz.bind(this)
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.pobierzEkipy = this.pobierzEkipy.bind(this)
        this.pobierzKierowcow = this.pobierzKierowcow.bind(this)
    }

    pobierzPolaczenia() {
        EkipyKierowcyService.getEkipaKier().then(function (response) {
            this.setState({polaczenia: response.data})
        }.bind(this))
    }

    pobierzEkipy() {
        EkipyService.getEkipy().then(function (response) {
            this.setState({ekipy: response.data.content, ekipyTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data.content,"idEk",'kodEk','nazwaEk', null)})
        }.bind(this))
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcy().then(function (response) {
            this.setState({kierowcy: response.data, kierowcyTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data,"idKi",'imie','nazwisko', null)})
        }.bind(this))
    }

    componentDidMount() {
        this.pobierzPolaczenia();
        this.pobierzKierowcow();
        this.pobierzEkipy();
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, polaczenie: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({polaczenie: obj})
    }

    onClickUsun(obj) {

        if (window.confirm('Czy usunąc połączenie?')) {
            EkipyKierowcyService.deleteEkipaKier(obj.idEkk).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto połączenie', "", 3000)
                    this.pobierzPolaczenia();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania połączenia', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            EkipyKierowcyService.editEkipaKier(this.state.polaczenie.idEkk, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano połączenie', "", 3000)
                    this.pobierzPolaczenia();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji połączenia', "", 3000)
                }
            }.bind(this))
        }
        else {
            EkipyKierowcyService.addEkipaKier(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano połączenie', "", 3000)
                    this.pobierzPolaczenia();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania połączenia', "", 3000)
                }
            }.bind(this))
        }

        this.zamknijFormularz();
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                            <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                tekstDodaj={'Dodaj kierowcę do ekipy'}
                                                pokazButtonSzukaj={false}
                            />
                        </TopIf>
                        <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                            <PolaczenieEkipyForm
                                handleClickZapisz={this.onClickZapisz}
                                handleClickAnuluj={this.zamknijFormularz}
                                polaczenie={this.state.polaczenie}
                                kierowcy={this.state.kierowcy}
                                ekipy={this.state.ekipy}
                                polaczenia={this.state.polaczenia}
                            />
                        </TopIf>
                        <TopIf isTrue={Boolean(this.state.polaczenia)}>
                            <PolaczenieEkipyTable data={this.state.polaczenia}
                                                  wlaczSzukanie={true}
                                                  handleEdytuj={this.onClickEdytuj}
                                                  handleUsun={this.onClickUsun}
                                                  kierowcy={this.state.kierowcy}
                                                  ekipy={this.state.ekipy}
                                                  ekipyTS={this.state.ekipyTS}
                                                  kierowcyTS={this.state.kierowcyTS}
                            />
                        </TopIf>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipy/PolaczenieEkipyContainer.js